module.exports = __webpack_public_path__ + "static/media/services-bg-2.13257785.webp";